// Components/MessagesArea/components/EmptyConversation.jsx
import React from 'react';
import { Box, Typography } from '@mui/material';

const EmptyConversation = () => {
    return (
        <Box sx={{ 
            display: 'flex', 
            flexDirection: 'column',
            justifyContent: 'center', 
            alignItems: 'center', 
            height: '100%',
            color: '#aaa'
        }}>
            <Typography variant="body1">
                No hay mensajes aún
            </Typography>
            <Typography variant="body2">
                Envía un mensaje para iniciar la conversación
            </Typography>
        </Box>
    );
};

export default EmptyConversation;